export default "__VITE_ASSET__4GXMtu3v__"